import styled from 'styled-components'
import {down} from 'styled-breakpoints'

const headerOverflow = '80px'

const BD = styled.article`
  img {
    width: 100%;
    height: auto;
  }
`

BD.Header = styled.header.attrs(
  (props) => ({
    style: {
      backgroundImage: `url('${props.thumbnail}')`,
    },
  }),
)`
  padding-bottom: ${headerOverflow};
  position: relative;
  z-index: -1;
  background: no-repeat center / cover;

  &::before {
    content: '';
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: -1;
    background: rgba(0, 0, 0, 0.3);
  }
`

BD.HeaderInner = styled.div`
  padding-top: ${headerOverflow};
  padding-bottom: ${headerOverflow};
  text-align: center;
`

BD.Date = styled.div`
  color: white;
  margin-bottom: 10px;
  font-weight: 600;
`

BD.Title = styled.h1`
  margin-bottom: 0;
  color: white;
`

BD.MainContainer = styled.div`
  margin-top: -${headerOverflow};
  padding: 50px;
  background: white;

  ${down('sm')} {
    margin-left: -15px;
    margin-right: -15px;
    padding-left: 15px;
    padding-right: 15px;
    padding-bottom: 10px;
  }
`

BD.LeftContent = styled.div`
  ${down('sm')} {
    margin-bottom: 40px;
  }
`

BD.SliderWrapper = styled.div`
  margin-bottom: 40px;
`

BD.Content = styled.div`
  margin-bottom: 40px;
`

BD.Footer = styled.footer`
  display: flex;
  align-items: flex-start;

  ${down('sm')} {
    flex-wrap: wrap;
  }
`

BD.Tags = styled.div`
  flex-grow: 1;
  display: flex;
  text-transform: uppercase;

  ${down('sm')} {
    width: 100%;
    margin-bottom: 20px;
  }
`

BD.TagItem = styled.div`
  border: 1px solid #F0F0F0;
  border-radius: 4px;
  padding: 5px 10px;

  &:not(:last-child) {
    margin-right: 6px;
  }
`

export default BD
